@if (lineItems$ | async; as lineItems) {
<div class="product-rows-block">
  @if (basketError$ | async; as basketError) {
  <ish-basket-error-message [error]="basketError" cssClass="text-danger" />
  }
  <ish-basket-validation-results />
  @for (lineItem of lineItems | slice : 0 : maxItemNumber; track lineItem) {
  <div class="product-row">
    <ng-container ishProductContext [sku]="lineItem.productSKU">
      <div class="mini-product-img">
        <ish-product-image imageType="S" [link]="true" />
      </div>
      <div class="mini-product-info">
        <ish-product-name />
        <div class="position-absolute mini-cart-icons">
          <a class="mini-cart-cog">
            <custom-edit-line-item [pli]="lineItem" [icon]="['fas', 'cog']" />
          </a>
          @if (!lineItem.isFreeGift) {
          <custom-mini-cart-remove-item-confirmation-modal (confirm)="onDeleteItem(lineItem.id)" [options]="options">
            <p>{{ 'mini_cart.remove_item.confirmation.modal.content' | translate }}</p>
          </custom-mini-cart-remove-item-confirmation-modal>
          }
        </div>
        <div class="cart-pli-data">
          <span>{{ 'shopping_cart.pli.qty.label' | translate }}</span> {{ lineItem.quantity.value }}
        </div>
        <div class="product-price">{{ lineItem.price | ishPrice }}</div>
      </div>
    </ng-container>
  </div>
  } @if (maxItemNumber && lineItems.length >= maxItemNumber + 1) {
  <div class="alert alert-info mb-0" data-testing-id="show-all-cart-items-hint">
    {{ 'shopping_cart.ministatus.show_all_items.text' | translate }}
  </div>
  }
</div>
<div class="mini-cart-bottom-section">
  <div class="mini-cart-subtotal">
    <label>Cart Subtotal:</label>
    @if (itemTotal$ | async; as itemTotal) {
    <span class="mini-cart-price">{{ itemTotal | ishPrice }}</span>
    }
  </div>
  <button class="btn btn-lg btn-block btn-primary" routerLink="/basket">
    {{ 'shopping_cart.ministatus.view_cart.link' | translate }}
  </button>
  <button
    *ishHasNotRole="['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER']"
    type="submit"
    class="btn btn-lg btn-block btn-primary"
    (click)="minicheckout()"
  >
    {{ 'shopping_cart.proceed_to_checkout.button.label' | translate }}
  </button>
</div>
} @else { @if (basketError$ | async; as basketError) {
<ish-basket-error-message [error]="basketError" cssClass="text-danger" />
}
{{ 'shopping_cart.ministatus.empty_cart.text' | translate }}
}
